// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"f1bd3f17","363":"d605f1fe","433":"511cfb0f","453":"89f79772","525":"39632969","819":"983f665d","967":"56c535cd"}[chunkId] + ".chunk.js";
};